import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { Formik, Form } from "formik";
import { useSelector } from "react-redux";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import { useTransferKeyResult} from "../../Hooks";
import "../../../CompanyManagment/Forms/RegisterTenant/Error.css";
import { useGetAllObjectivesByPeriodId } from "../../../IndexManaging/Hooks/Index";
import DyLoadingCircular from "../../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";

const TransferKeyResult = ({
  onSuccess,
  setShowToastMessage,
  setObjectiveAsyncOpState,
  afterSuccess,
  onClose,
  teamIdd,
  krId,
  periodId
}: any) => {
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const {
    mutate: addObjective,
    data: addObjectiveData,
    isSuccess,
    isLoading,
    isError: isErrorInAddObjective,
  } = useTransferKeyResult();

  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const { data: teamsOptions, isLoading: teamOPloading } =
  useGetAllObjectivesByPeriodId(tenantId,periodId);
  
  useEffect(() => {
    if (addObjectiveData) {
      if (addObjectiveData?.data.isSuccess) {
        setShowToastMessage(true);
        onClose(false);
      } else {
        setShowLtoastMessage(true);
        SetIsSuccess(false);
        SetTMessage(addObjectiveData?.data.metaData.message);
      }
    }
  }, [addObjectiveData]);

  const initialAddObjective = async (data: any) => {
    data.id = krId;
    data.periodId = periodId;
    await addObjective({...data,tenantId:tenantId});
  };

  return (
    <>
      <Box width={"100%"} maxHeight={"50em"}>
        <Formik
          enableReinitialize
          validate={(data) => {
            
          }}
          initialValues={{ }}
          onSubmit={(data) => {
            initialAddObjective(data);
          }}
        >
          {({
            values,
            setFieldValue,
            dirty,
            isValid,
            touched,
            errors,
            setFieldTouched,
            handleChange,
          }: any) => (
            <Form>
              <Grid container>
              <Grid item xs={12} md={12} mt={1}>
                  <Box padding={"8px"}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="demo-simple-select-label">اهداف</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-selectd"
                        value={values?.objectiveId || ""}
                        label="اهداف"
                        onChange={(e: any, other: any) => {
                          let { target } = e;
                          let { value } = target;
                          setFieldValue("objectiveId", value);
                        }}
                      >
                        {teamOPloading && (
                          <Box width={"100%"} textAlign={"center"}>
                            <DyLoadingCircular />
                          </Box>
                        )}
                        {teamsOptions &&
                          teamsOptions.map((item: any) => {
                            let { key, value, isCompany } = item;
                            return (
                              <MenuItem
                                key={key}
                                value={value}
                                content={isCompany}
                              >
                                {key}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} md={12} mt={3}>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"end"}
                    flexDirection={"row-reverse"}
                    columnGap={2}
                  >
                      <Box width={"20%"}>
                            <DyButton
                              disabled={false}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={'ثبت'}
                              type={"submit"}
                              onClick={() => { }}
                            />
                          </Box>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
      </Box>
    </>
  );
};

export default TransferKeyResult;